import { PrivateRouter } from 'app/routers/private/PrivateRouter'
import { DashboardFilterTP } from 'app/screens/screen-home/inner/DashboardFilterTP'
import { RoutingHelper } from 'config/RoutingHelper'
import { IDateRangeFilter } from 'submodules/nerit-framework-ui/common/components/form-fields/date-range-picker/inner/IDateRangeFilter'
import { NeritFrameworkRoutingHelper } from 'submodules/nerit-framework-ui/common/router/utils/NeritFrameworkRoutingHelper'
import { SCREEN_FILTER_URL_PARAM } from 'submodules/nerit-framework-ui/common/screens/inner/ScreenTypes'

/**
 * Atalhos do Dashboard: abrem as ferramentas já filtradas com o filtro do cabeçalho.
 */
export class DashboardLinksUtils {

    static goToDataAnalysis(filter: DashboardFilterTP): void {
        DashboardLinksUtils._goTo(PrivateRouter.DATA_ANALISYS, {
            samplingCode: [filter.samplingCode],
            locationCodes: filter.locationCodes,
            regulationCode: filter.regulationCode,
            dateRange: filter.dateRange,
            fieldCodes: [],
        })
    }

    static goToWaterContamination(filter: DashboardFilterTP, fieldCodes: number[]): void {
        DashboardLinksUtils._goTo(PrivateRouter.WATER_CONTAMINATION, {
            locationCodes: filter.locationCodes,
            regulationCode: filter.regulationCode,
            dateRange: filter.dateRange,
            fieldCodes,
        })
    }

    static goToNonConformity(filter: DashboardFilterTP): void {
        DashboardLinksUtils._goTo(PrivateRouter.NON_CONFORMITY, {
            locationCodes: filter.locationCodes,
            regulationCode: filter.regulationCode,
            dateRange: filter.dateRange,
        })
    }

    static goToIonicBalance(): void {
        NeritFrameworkRoutingHelper.historyPush(PrivateRouter.QAQC_IONIC_BALANCE_HISTORY)
    }

    static goToAnomalyEvaluation(): void {
        NeritFrameworkRoutingHelper.historyPush(PrivateRouter.QAQC_ANOMALY_EVALUATION_HISTORY)
    }

    static goToCollectionControl(matrixCode: number | undefined, locationCodes: number[], dateRange: IDateRangeFilter): void {
        DashboardLinksUtils._goTo(PrivateRouter.COLLECTION_CONTROL, { matrixCode, locationCodes, dateRange })
    }

    static goToMap(filter: DashboardFilterTP, fieldCode?: number): void {
        DashboardLinksUtils._goTo(PrivateRouter.MAP, {
            samplingCode: filter.samplingCode,
            regulationCode: filter.regulationCode,
            dateRange: filter.dateRange,
            fieldCode,
        })
    }

    static goToHistoricSeries(filter: DashboardFilterTP, fieldCode: number, locationCode: number, dateRange: IDateRangeFilter): void {
        RoutingHelper.goToChartHistorical({
            fieldCodes: [fieldCode],
            locationCode,
            regulationCode: filter.regulationCode,
            dateRange,
        })
    }

    private static _goTo(route: string, filters: object): void {
        NeritFrameworkRoutingHelper.historyPush(`${route}?${SCREEN_FILTER_URL_PARAM}=${encodeURIComponent(JSON.stringify(filters))}`)
    }

}
